// extracted by mini-css-extract-plugin
module.exports = {"warning":"styles_warning__363Be","buttons":"styles_buttons__dGmo6"};